import { render, staticRenderFns } from "./classTotal.vue?vue&type=template&id=6fb81585&scoped=true"
import script from "./classTotal.vue?vue&type=script&lang=js"
export * from "./classTotal.vue?vue&type=script&lang=js"
import style0 from "./classTotal.vue?vue&type=style&index=0&id=6fb81585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb81585",
  null
  
)

export default component.exports